<div class="d-flex flex-column justify-content-center align-items-center mt-3 section-photo-container">
    <image-cropper
        #imageCropper
        [imageChangedEvent]="fileChangedEvent"
        [imageBase64]="_initialImage"
        [maintainAspectRatio]="false"
        [aspectRatio]="1"
        [resizeToWidth]="1024"
        [allowMoveImage]="true"
        format="png"
        (imageCropped)="imageCropped($event)"
        (loadImageFailed)="loadImageFailed()"
        [(transform)]="imageTransform"
    />
</div>

<div class="d-flex flex-column justify-content-center align-items-center mb-4 section-photo-container">
    <div *ngIf="!_initialImage && !croppedImage" (click)="imagePublicInput.click()">
        <ng-content />
    </div>

    <input
        type="file"
        (change)="fileChangeEvent($event)"
        accept=".jpg, .jpeg, .png"
        hidden
        #imagePublicInput
    />
</div>

<div>
    <div
        class="d-flex w-100 align-items-center"
        [class.justify-content-between]="!!croppedImage"
        [class.justify-content-end]="!croppedImage"
    >
        <p-slider
            *ngIf="croppedImage"
            [ngModel]="imageTransform.scale"
            (ngModelChange)="cropSizeChanged($event)"
            [min]="0.5"
            [max]="1.5"
            [step]="0.05"
            [style]="{ width: '200px' }"
        />

        <div class="btn btn-outline-danger" (click)="removeImage()" *ngIf="!!croppedImage">
            Clear
        </div>

        <div class="btn btn-outline-primary" (click)="imagePublicInput.click()" *ngIf="!croppedImage">
            Upload
        </div>
    </div>
</div>
